import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'service';

export default {
  async search(queryParams) {
    const url = mountUrl(`/${BASE_PATH}`, queryParams);
    return api.get(url);
  },
  async create(data) {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.post(url, data);
  },
  async update(serviceId, data) {
    const url = mountUrl(`/${BASE_PATH}/${serviceId}`);
    return api.patch(url, data);
  },
  async inactivate(serviceId) {
    const url = mountUrl(`/${BASE_PATH}/${serviceId}`);
    return api.delete(url);
  }
};
